import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { EventTypes, eventStatus } from '../../constants';
import { LoadingStatusWrapper } from 'sharedComponents';
import { pageSize } from './constants';
import { IconLeftArrow } from 'svgIcons/MotionPortalIcons';
import { paginateCommentList } from 'helpers/paginationHelper';
import EventDetailsSSCommentList from './EventDetailsSSCommentList';
import EventDetailsSSCommentActions from './EventDetailsSSCommentActions';
import ErrorView from 'sharedComponents/ErrorBoundary/ErrorView';
import { apiCallStatus } from 'helpers/constants';
import { useReportIssue } from 'sharedHooks/useReportIssue';
import './style.scss';
import { formatDateTime } from 'helpers/dateTimeFormatter';


const EventDetailsSSComponent = (props) => {

    const { t: translate } = useTranslation();
    const { showReportIssue } = useReportIssue();
    const event = props.model.selectedEvent.rawEvent;

    const [selectedPage, setSelectedPage] = useState(1);
    const [displayedComments, setDisplayedComments] = useState([]);

    const calculateDisplayedCommentList = (startIndex, endIndex) => {
        setDisplayedComments(paginateCommentList(props.model.eventComments?.data, startIndex, endIndex));
    };

    useEffect(() => {
        props.actions.getComments(event);
    }, []);

    useEffect(() => {
        calculateDisplayedCommentList((selectedPage - 1) * pageSize, selectedPage * pageSize - 1);
    }, [selectedPage, props.model.eventComments.data]);

    useEffect(() => () => {
        props.setSelectedEvent(null);
    }, []);

    if (props.model.eventCommentsErrorData?.loadingStatus === apiCallStatus.ERROR) {
        return <ErrorView
            errorCode={props.model.eventCommentsErrorData.errorCode}
            onRetry={() => {
                props.actions.clearStore();
                props.actions.getComments(event);
            }}
            onReportIssue={showReportIssue}
        />;
    }

    return (
        <div className='event-detailsSS-content'>
            <div className='event-details-header'>
                <div className='event-type-icon'>{EventTypes?.find(et => et.typeID === event?.severityCode)?.icon}</div>
                <div className='event-type-group' xl={{ span: 5, order: 1 }} xs={{ span: 9, order: 1 }}>
                    <div>{event?.messageText}</div>
                    <div className='event-log-additional-details'>
                        {/* Hiding the Advice field as per PBI 407211 will be available in the future PI's*/}
                        {/* <div>{translate('ABB.Powertrain.Frontend.eventDetailsAdviceLbl')}: {event?.description}</div> */}
                        <div>{translate('ABB.Powertrain.Frontend.eventDetailsLoggedOnLbl')}: {formatDateTime(event?.timestamp)}</div>
                    </div>
                </div>
                <div className='back-to-event-list'>
                    <div className='switch-component'>
                        <IconLeftArrow />
                        <span> {translate('ABB.Powertrain.Frontend.eventDetailsBackToLbl')} </span>
                        <button onClick={() => {
                            const eventMessageText = props.model?.selectedEvent?.messageText;
                            props.setSelectedEvent(null);
                            props.setSelectedEventPage(props?.eventPage, eventMessageText);
                            props.setSelectedEventPage(props?.eventPage, props?.model?.selectedEvent, props?.eventItemPage);
                        }}>
                            <span className='event-list-lbl'> {translate('ABB.Powertrain.Frontend.eventDetailsEventListLbl')} </span>
                        </button>
                    </div>
                </div>
            </div>
            <div className='event-details-comments-section'>
                <Row>
                    <LoadingStatusWrapper loadingStatus={props.model.eventClosingLoadingStatus}>
                        {event?.lifecycle !== eventStatus.CLOSED ?
                            <EventDetailsSSCommentActions
                                model={props.model}
                                actions={props.actions}
                                asset={props.asset}
                            /> : null
                        }
                        <EventDetailsSSCommentList
                            model={props.model}
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                            displayedComments={displayedComments}
                        />
                    </LoadingStatusWrapper>
                </Row>
            </div>
        </div>
    );
};

EventDetailsSSComponent.propTypes = {
    actions: PropTypes.shape({
        getComments: PropTypes.func, // Function to fetch comments for the event
        clearStore: PropTypes.func, // Function to clear local EventDetailsSS state
    }), // Actions object containing functions
    setSelectedEvent: PropTypes.func, // Function to set the selected event
    model: PropTypes.shape({
        eventCommentsErrorData: PropTypes.shape({
            loadingStatus: PropTypes.string,
            errorCode: PropTypes.number,
        }),
        eventComments: PropTypes.shape({
            loadingStatus: PropTypes.string, // Loading status of the event comments
            data: PropTypes.arrayOf(
                PropTypes.shape({
                    authorEmail: PropTypes.string, // Email of the comment author
                    timeStamp: PropTypes.string, // Timestamp of the comment
                    text: PropTypes.string, // Text of the comment
                })
            ), // Array of event comments
        }), // Event comments data
        selectedEvent: PropTypes.shape({
            rawEvent: PropTypes.shape({
                severityCode: PropTypes.string, // Severity code of the event
                messageText: PropTypes.string, // Message text of the event
                timestamp: PropTypes.string, // Timestamp of the event
                lifecycle: PropTypes.string, // Lifecycle status of the event
            }), // Raw event details
            messageText: PropTypes.string, // Added validation for messageText
        }), // Selected event details
        eventClosingLoadingStatus: PropTypes.string, // Loading status for event closing
    }), // Model containing state data
    eventPage: PropTypes.number, // Current event page number
    eventItemPage: PropTypes.number, // Current event item page number
    setSelectedEventPage: PropTypes.func, // Function to set the selected event page
    asset: PropTypes.shape({
        id: PropTypes.string, // Asset ID
        name: PropTypes.string, // Asset name
    }), // Asset details
};

export default EventDetailsSSComponent;

